var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-opacity-30 left-0 top-0 transition-all",class:{
    'bg-black fixed h-screen w-screen z-50 xl:bg-transparent xl:w-0 xl:h-0':
      _vm.isActive,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }